import TabsPage from "../components/tabsPage";
import { DecodeHtml } from "../utils/decodeHtml";
import { retrunAssets } from "../utils/getAssets";
import useFetch from "../utils/useFetch";


const Payment = () => {

    const base = "student-hub/";
    const state1 = useFetch(base + "current-students/");
    const state2 = useFetch(base + "new-students/");

    const data1 = state1?.properties;
    const data2 = state2?.properties;

    const title = data1?.title;
    const bg = data1?.backgroundImage != null ? retrunAssets(data1?.backgroundImage[0]?.url) : "";

    const data = [data1, data2]?.map(item => {
        return (
            {
                header: item?.title,
                content:
                    <div className="flex flex-col gap-5 w-full">
                        <p>{item?.shortText}</p>
                        <div className="flex flex-col gap-5 border-t border-b py-4 w-full">
                            {
                                item?.paymentType?.items?.map((payment, i) => {
                                    payment = payment?.content?.properties
                                    return (
                                        <div key={i} className="flex flex-col gap-3 md:flex-row md:gap-10 w-full">
                                            <h1 className="text-4xl font-medium md:max-w-[30%] flex-1 w-full">{payment?.type}</h1>
                                            <p className="whitespace-pre-line font-normal flex-1">{DecodeHtml({ html: payment?.contents?.markup })}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <p className="whitespace-pre-line font-normal  overflow-x-auto">{DecodeHtml({ html: item?.bottomText?.markup })}</p>

                    </div>
            }
        )
    })




    return (
        <TabsPage title={title} bg={bg} data={data} />
    )
}

export default Payment